import $ from 'jquery';
import Vue from 'vue';
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import DatePicker from 'vuejs-datepicker';
import { WindowType } from '../../../util';
import { CellList, DatePatternType, ListItem, ListItemCell, Media, VMDutyCreate } from '../../backend/backendapi';
import { CellTree } from "../../cell/cell.model";
import { mapTree } from "../../cell/cell.util";
import MiscTab from "./misc/MiscTab";
import HelpModal from './HelpModal';
import TodoList from '../../todolist/TodoList';
import DropZone from '../../dropzone/DropZone';

export class ListItemDropdown {
    id: string = "";
    name: string = "";
}

declare var window: WindowType;

type VSelectCellEntry = ListItemCell & { ident?: string };

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'EditModal',
    components: {
        DatePicker,
        DropZone,
        FormWizard,
        HelpModal,
        MiscTab,
        TabContent,
        TodoList,
        vSelect,
        ImageViewer: require('../../imageviewer/imageviewer.vue.html').default,
    }
})
export default class EditModal extends Vue {
    @Prop({ required: true })
    private readonly cells!: CellList[];
    @Prop({ required: true })
    private readonly users!: ListItem[];
    @Prop({ required: true })
    private readonly dutyCreate!: VMDutyCreate | null;
    @Prop({ required: true })
    private readonly techAreaOptions!: string[];

    private isMaintenance: boolean = true;

    async mounted(): Promise<void> {
        this.isMaintenance = window.application.check2.isMaintenanceMode // user rights and features
    }

    public open(): void {
        $(this.$refs.modal!).modal('show');
        if (this.dutyCreate) {
            this.selectFirstTab();
        }
        //needs to be delayed since vue-form-wizard component is conditionally rendered depending on dutyCreate not being nullish
        this.$nextTick(() => (this.$refs.addModalFormWizard as any as FormWizard).activateAll());
    }

    public dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private onComplete(): void {
        if (!this.dutyCreate) {
            return;
        }

        this.$emit('complete');
    }

    private onDzComplete(file: any): void {
        if (!this.dutyCreate) {
            return;
        }
        if (file.status === "success" && file.xhr.responseText !== "") {
            var response = JSON.parse(file.xhr.responseText);
            let newFile = new Media();
            newFile.id = response.fileId;
            newFile.contentType = "NA";
            newFile.filename = file.name;
            newFile.size = file.size;
            newFile.created = file.lastModifiedDate;
            if (!this.dutyCreate.duty.files) {
                this.dutyCreate.duty.files = [];
            }
            this.dutyCreate.duty.files.push(newFile);
            console.log("file upload ok");
        }
        if (file.status !== "success" && file.xhr.responseText !== "") {
            var response = JSON.parse(file.xhr.responseText);
            file.previewElement.querySelector("[data-dz-errormessage]").innerText = response.body;
        }
    }

    private updateTodolist(strJson: string): void {
        //alert('todo changed: json=' + strJson);
        if (!this.dutyCreate) {
            return;
        }
        console.log("updateTodolist=" + strJson);
        this.dutyCreate.strJsonTodo = strJson;
    }

    private selectFirstTab(retry: boolean = true): void {
        let formwizard = this.$refs.addModalFormWizard as FormWizard;
        if (formwizard) {
            formwizard.reset();
            return;
        }
        if (retry) {
            this.$nextTick(() => this.selectFirstTab(false));
        }
    }

    //getter
    private get yearDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        var datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0].includes(datePattern);
    }

    private get monthDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0, 2].includes(datePattern);
    }

    private get weekOfMonthDisabled(): boolean {
          if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0, 1, 2].includes(datePattern);
    }

    private get dayDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0, 2, 4].includes(datePattern);
    }

    private get weekNumberDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0, 1, 4].includes(datePattern);
    }

    private get weekdayDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [0, 1].includes(datePattern);
    }

    private get intervalDisabled(): boolean {
        if (!this.dutyCreate) {
            return true;
        }
        let datePattern = this.dutyCreate.duty.datePattern!;
        if (datePattern < 0 || datePattern >= 16) {
            return true;
        }
        return [1, 2, 4].includes(datePattern);
    }

    private get dateStart(): Date {
        return this.dutyCreate!.duty.firstDate!.start!;
    }

    private set dateStart(val: Date) {
        this.dutyCreate!.duty.firstDate!.start = val;
        this.dutyCreate!.duty.firstDate!.repeatStart = val;
    }

    private get yearOptions(): ListItemDropdown[] {
        const ret: ListItemDropdown[] = []
        ret.push({ id: "*", name: this.$i18n.t('txtEachYear').toString() });
        for (let i = 0; i <= 20; i++) {
            ret.push({ id: (2020 + i).toString(), name: (2020 + i).toString() });
        }
        return ret;
    }
    
    private get weekOption(): ListItemDropdown[] {
        let ret: ListItemDropdown[] = []
        ret.push({ id: "*", name: this.$i18n.t('txtEachWeek').toString() });
        for (var i = 1; i <= 52; i++) {
            ret.push({ id: i.toString(), name: i.toString() });
        }
        return ret;
    }

    private get weekdayOption(): ListItemDropdown[] {
        return [
            { id: '0', name: this.$t('txtSunday').toString() },
            { id: '1', name: this.$t('txtMonday').toString() },
            { id: '2', name: this.$t('txtTuesday').toString() },
            { id: '3', name: this.$t('txtWednesday').toString() },
            { id: '4', name: this.$t('txtThursday').toString() },
            { id: '5', name: this.$t('txtFriday').toString() },
            { id: '6', name: this.$t('txtSaturday').toString() },
        ];
    }

    private get weekOfMonthOptions(): ListItemDropdown[] {
      return [
        { id: '1', name: '1. ' + this.$t('txtWeek') },
        { id: '2', name: '2. ' + this.$t('txtWeek') },
        { id: '3', name: '3. ' + this.$t('txtWeek') },
        { id: '4', name: '4. ' + this.$t('txtWeek') },
        { id: '5', name: '5. ' + this.$t('txtWeek') },
      ];
    }

    private set weekOfMonthOptionSelected(value: string[]) {
      if (!this.dutyCreate || !this.dutyCreate.duty.firstDate) return;
      if (!value || value.length === 0) {
        this.dutyCreate.duty.firstDate.repeatWeekOfMonth = "*";
      } else {
        if (typeof value[0] === 'object') {
          this.dutyCreate.duty.firstDate.repeatWeekOfMonth = value.map(v => v.id).join(',');
        } else {
          // If v-select returns just IDs (because of :reduce)
          this.dutyCreate.duty.firstDate.repeatWeekOfMonth = value.join(',');
        }
      }
    }

    private get weekOfMonthOptionSelected(): ListItemDropdown[] {
        if (!this.dutyCreate) {
            return [];
        }

        // Clear dates if the pattern is switched to something incompatible
        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday
            && this.dutyCreate.duty.dates?.length) {
            this.dutyCreate.duty.dates.splice(0);
        }

        // Ensure firstDate is populated from the array if necessary
        if (this.dutyCreate.duty.dates?.length) {
            this.parseIntoFirstDate();
        }

        // Only return selection if the specific "Week of Month" pattern is active
        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday) {
            return [];
        }

        // Parse the comma-separated string (e.g., "1,3,L") into ListItems
        return this.dutyCreate.duty.firstDate?.repeatWeekOfMonth?.split(',').map(e => {
            return {
                id: e,
                name: e !== '*'
                    ? (this.weekOfMonthOptions.find(o => o.id === e)?.name ?? e)
                    : this.$i18n.t('txtEachWeek').toString()
            };
        }) ?? [];
  }

    private get yearOptionSelected(): ListItemDropdown[] {
        if (!this.dutyCreate) {
            return [];
        }
        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthDay
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday
            && this.dutyCreate.duty.dates?.length) {
            this.dutyCreate.duty.dates.splice(0);
        }
        if (this.dutyCreate.duty.dates?.length) {//parse dates into firstdate
            this.parseIntoFirstDate();
        }

        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthDay
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday ) {
            return [];
        }
        return this.dutyCreate.duty.firstDate?.repeatYear?.split(',').map(e => {
            return {
                id: e,
                name: e !== '*'
                    ? (this.yearOptions.find(o => o.id === e)?.name ?? e)
                    : this.$i18n.t('txtEachYear').toString()
            };
        }) ?? [];
    }

    private set yearOptionSelected(v: ListItemDropdown[]) {
        if (!this.dutyCreate) {
            return;
        }
        let year = "*";
        if (v.length > 0) {
            year = v.map(e => e.id).join(',');
        }
        this.dutyCreate.duty.firstDate!.repeatYear = year;
        this.dutyCreate.duty.dates = [];
    }
    
    private get weekOptionSelected(): ListItemDropdown[] {
        if (!this.dutyCreate) {
            return [];
        }
        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday && this.dutyCreate.duty.dates?.length) {
            this.dutyCreate.duty.dates.splice(0);
        }
        if (this.dutyCreate.duty.dates?.length) {//parse dates into firstdate
            this.parseIntoFirstDate();
        }

        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday) {
            return [];
        }
        return this.dutyCreate.duty.firstDate?.repeatWeek?.split(',').map(e => {
            return {
                id: e,
                name: e !== '*'
                    ? (this.weekOption.find(o => o.id === e)?.name ?? e)
                    : this.$i18n.t('txtEachWeek').toString()
            };
        }) ?? [];
    }

    private set weekOptionSelected(v: ListItemDropdown[]) {
        if (!this.dutyCreate) {
            return;
        }
        let weeks = "*";
        if (v.length > 0) {
            weeks = v.map(e => e.id).join(',');
        }
        this.dutyCreate.duty.firstDate!.repeatWeek = weeks;
        this.dutyCreate.duty.dates = [];
    }

    private get weekdayOptionSelected(): ListItemDropdown[] {
        if (!this.dutyCreate) {
            return [];
        }
        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday
            && this.dutyCreate.duty.dates?.length) {
            this.dutyCreate.duty.dates.splice(0);
        }
        if (this.dutyCreate.duty.dates?.length) {//parse dates into firstdate
            this.parseIntoFirstDate();
        }

        if (this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekWeekday
            && this.dutyCreate.duty.datePattern !== DatePatternType.YearMonthWeekOfMonthWeekday) {
            return [];
        }
        return this.dutyCreate.duty.firstDate?.repeatWeekday?.split(',').map(e => {
            return {
                id: e,
                name: e !== '*'
                    ? (this.weekdayOption.find(o => o.id === e)?.name ?? e)
                    : this.$i18n.t('txtEachWeekday').toString()
            };
        }) ?? [];
    }

    private set weekdayOptionSelected(v: ListItemDropdown[]) {
        if (!this.dutyCreate) {
            return;
        }
        let weekdays = "*";
        if (v.length > 0) {
            weekdays = v.map(e => e.id).join(',');
        }
        this.dutyCreate.duty.firstDate!.repeatWeekday = weekdays;
        this.dutyCreate.duty.dates = [];
    }

    private get canNewTechArea(): boolean {
        return window.application.permissions.duty.newTechArea;
    }

    private get dueWeeks(): number {
        if (!this.dutyCreate) {
            return 0;
        }
        return Math.floor(this.dutyCreate.duty.dueSeconds / 3600 / 24 / 7);
    }

    private set dueWeeks(val: number) {
        if (!this.dutyCreate) {
            return;
        }
        let diff = val - this.dueWeeks;
        this.dutyCreate.duty.dueSeconds += diff * 3600 * 24 * 7;
    }

    private get dueDays(): number {
        if (!this.dutyCreate) {
            return 0;
        }
        return Math.floor(this.dutyCreate.duty.dueSeconds / 3600 / 24) % 7;
    }

    private set dueDays(val: number) {
        if (!this.dutyCreate) {
            return;
        }
        let diff = val - this.dueDays;
        this.dutyCreate.duty.dueSeconds += diff * 3600 * 24;
    }

    private get dueHours(): number {
        if (!this.dutyCreate) {
            return 0;
        }
        return Math.floor(this.dutyCreate.duty.dueSeconds / 3600) % 24;
    }

    private set dueHours(val: number) {
        if (!this.dutyCreate) {
            return;
        }
        let diff = val - this.dueHours;
        this.dutyCreate.duty.dueSeconds += diff * 3600;
    }

    private get repeatHour(): number {
        if (!this.dutyCreate) {
            return 0;
        }
        return this.dutyCreate.duty.firstDate!.repeatHour! % 24;
    }

    private set repeatHour(val: number) {
        if (!this.dutyCreate) {
            return;
        }
        this.dutyCreate.duty.firstDate!.repeatHour = val;
    }

    private get cellTree(): CellTree[] {
        return mapTree(this.cells);
    }

    private get dutyCreateCells(): VSelectCellEntry[] {
        return this.dutyCreate?.cells?.map(e => this.cellsForVSelectById.get(e.id!)).filter(e => !!e).map(e => e!) ?? [];
    }

    private set dutyCreateCells(cells: VSelectCellEntry[]) {
        if (!this.dutyCreate) {
            return;
        }
        this.dutyCreate.cells = cells.map(e => this.listItemCellsById.get(e.id!)).filter(e => !!e).map(e => e!);
    }

    private get cellsForVSelect(): VSelectCellEntry[] {
        let flatMapper = (tree: CellTree, prefix: string) => {
            return [{ id: tree.item.id!, name: prefix + tree.item.name!, ident: tree.item.ident }]
                .concat(tree.children.map(e => flatMapper(e, prefix + tree.item.name! + ' > ')).reduce((l, r) => l.concat(r), []));
        };
        return this.cellTree.map(e => flatMapper(e, '')).reduce((l, r) => l.concat(r), []);
    }

    private get listItemCellsById(): Map<number, VSelectCellEntry> {
        return new Map<number, VSelectCellEntry>(this.cells.map(e => [e.id!, Object.assign(new ListItemCell({ id: e.id, name: e.name }), { ident: e.ident! })]));
    }

    private get cellsForVSelectById(): Map<number, VSelectCellEntry> {
        return new Map<number, VSelectCellEntry>(this.cellsForVSelect.map(e => [e.id!, e]));
    }

    private parseIntoFirstDate(): void {
        if (!this.dutyCreate) {
            return;
        }
        if (!this.dutyCreate.duty.dates?.length) {
            return;
        }

        //year
        this.dutyCreate.duty.firstDate!.repeatYear = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthWeekWeekday
                || e.datePattern === DatePatternType.YearMonthDay)
            .map(e => e.repeatYear ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatYear) {
            this.dutyCreate.duty.firstDate!.repeatYear = '*';
        }

        //month
        this.dutyCreate.duty.firstDate!.repeatMonth = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthWeekWeekday
                || e.datePattern === DatePatternType.YearMonthDay)
            .map(e => e.repeatMonth ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatMonth) {
            this.dutyCreate.duty.firstDate!.repeatMonth = '*';
        }

        //day
        this.dutyCreate.duty.firstDate!.repeatDay = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthDay)
            .map(e => e.repeatDay ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatDay) {
            this.dutyCreate.duty.firstDate!.repeatDay = '*';
        }

        //week
        this.dutyCreate.duty.firstDate!.repeatWeek = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthWeekWeekday)
            .map(e => e.repeatWeek ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatWeek) {
            this.dutyCreate.duty.firstDate!.repeatWeek = '*';
        }

         //RepeatWeekOfMonth
        this.dutyCreate.duty.firstDate!.repeatWeekOfMonth = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthWeekOfMonthWeekday)
            .map(e => e.repeatWeekOfMonth ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatWeekOfMonth) {
            this.dutyCreate.duty.firstDate!.repeatWeekOfMonth = '*';
        }

        //weekday
        this.dutyCreate.duty.firstDate!.repeatWeekday = this.dutyCreate.duty.dates
            .filter(e => e.datePattern === DatePatternType.YearMonthWeekWeekday
               || e.datePattern === DatePatternType.YearMonthWeekOfMonthWeekday)
            .map(e => e.repeatWeekday ?? '')
            .filter((value, index, self) => self.indexOf(value) === index) //unique filter
            .join(',');
        if (!this.dutyCreate.duty.firstDate!.repeatWeekday) {
            this.dutyCreate.duty.firstDate!.repeatWeekday = '*';
        }

        //clear
        this.dutyCreate.duty.dates.splice(0);
    }

    @Watch('dutyCreate')
    private onDutyCreateChange(newValue: VMDutyCreate | null, oldValue: VMDutyCreate | null) {
        if (!newValue) {
            return;
        }
        if (!oldValue || oldValue.duty.dutyId !== newValue.duty.dutyId) {
            this.selectFirstTab();
        }
        // this.onDutyCreateChangeDatePatternChanged(newValue.duty.firstDate!.datePattern);
    }

    @Watch('dutyCreate.duty.datePattern')
    private onDutyCreateChangeDatePatternChanged(newValue?: DatePatternType) {
        if (newValue === DatePatternType.Single) {
            this.dutyCreate!.duty.firstDate!.repeatInterval = undefined;
            this.dutyCreate!.duty.firstDate!.repeatDay = undefined;
            this.dutyCreate!.duty.firstDate!.repeatMonth = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeek = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekday = undefined;
            this.dutyCreate!.duty.firstDate!.repeatYear = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekOfMonth = undefined;
        } else if (newValue === DatePatternType.Interval) {
            this.dutyCreate!.duty.firstDate!.repeatDay = undefined;
            this.dutyCreate!.duty.firstDate!.repeatMonth = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeek = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekday = undefined;
            this.dutyCreate!.duty.firstDate!.repeatYear = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekOfMonth = undefined;
        } else if (newValue === DatePatternType.YearMonthDay) {
            this.dutyCreate!.duty.firstDate!.repeatInterval = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeek = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekday = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekOfMonth = undefined;
        } else if (newValue === DatePatternType.YearMonthWeekWeekday) {
            this.dutyCreate!.duty.firstDate!.repeatInterval = undefined;
            this.dutyCreate!.duty.firstDate!.repeatDay = undefined;
            this.dutyCreate!.duty.firstDate!.repeatMonth = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeekOfMonth = undefined;
        } else if (newValue === DatePatternType.YearMonthWeekOfMonthWeekday) {
            this.dutyCreate!.duty.firstDate!.repeatInterval = undefined;
            this.dutyCreate!.duty.firstDate!.repeatDay = undefined;
            this.dutyCreate!.duty.firstDate!.repeatWeek = undefined;
        }
    }

    private onMediaDeleted(): void {
        this.$toasted.info(this.$t('txtDeleted').toString());
    }

        /** Helper to format "1,2" into "Monday, Tuesday" or "*" into "Every Year" */
    private getYearPreview(): string {
        const val = this.dutyCreate?.duty.firstDate?.repeatYear;
        if (!val || val === '*') return this.$t('txtEachYear').toString();
        return val; // e.g. "2024, 2025"
    }

    private getMonthPreview(): string {
        const val = this.dutyCreate?.duty.firstDate?.repeatMonth;
        if (!val || val === '*') return this.$t('txtEachMonth').toString();
        // If you have a monthOptions getter, use it here; otherwise, just return numbers
        return this.$t('txtMonthInterfall').toString() + ' ' + val;
    }

    private getWeekdayPreview(): string {
        const val = this.dutyCreate?.duty.firstDate?.repeatWeekday;
        if (!val || val === '*') return this.$t('txtEachWeekday').toString();
    
        // Map IDs (0,1,2) to Names (Sunday, Monday...)
        return val.split(',').map(id => {
            return this.weekdayOption.find(o => o.id === id)?.name ?? id;
        }).join(', ');
    }

    private getWeekOfMonthPreview(): string {
        const val = this.dutyCreate?.duty.firstDate?.repeatWeekOfMonth;
        if (!val || val === '*') return this.$t('txtEachWeek').toString();
    
        // Map IDs (1,2,3) to Names (1. Week, 2. Week...)
        return val.split(',').map(id => {
            return this.weekOfMonthOptions.find(o => o.id === id)?.name ?? id;
        }).join(', ');
      }


      private getFormattedHour(): string {
        const hour = this.repeatHour; // Uses your existing getter
        if (hour === undefined || hour === null) return "00:00";
    
        // Pad with leading zero and add :00
        return hour.toString().padStart(2, '0') + ":00";
     }
}